var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-image"},[_c('div',{staticClass:"default-tip"},[_c('img',{attrs:{"src":require("../assets/images/default.png")}}),_c('span',{staticClass:"default-tip-text"},[_vm._v(_vm._s(_vm.$t('upDownManage.noRecord')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }